import apiClient from './client';
import type { Vocabulary } from '@voc-system/shared';

export interface CreateVocabularyDto {
  question: string;
  answer: string;
}

export interface UpdateVocabularyDto {
  question?: string;
  answer?: string;
}

export interface BulkCreateDto {
  vocabularies: CreateVocabularyDto[];
}

export interface VocabularyWithProgress extends Vocabulary {
  score?: number;
  phase?: number;
  lastSeen?: string | null;
}

export const vocabularyApi = {
  getByCourse: async (courseId: number): Promise<VocabularyWithProgress[]> => {
    const { data } = await apiClient.get(`/vocabulary/courses/${courseId}`);
    return data;
  },

  getById: async (id: number): Promise<Vocabulary> => {
    const { data } = await apiClient.get(`/vocabulary/${id}`);
    return data;
  },

  create: async (courseId: number, dto: CreateVocabularyDto): Promise<Vocabulary> => {
    const { data } = await apiClient.post(`/vocabulary/courses/${courseId}`, dto);
    return data;
  },

  update: async (id: number, dto: UpdateVocabularyDto): Promise<Vocabulary> => {
    const { data } = await apiClient.put(`/vocabulary/${id}`, dto);
    return data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/vocabulary/${id}`);
  },

  bulkCreate: async (courseId: number, dto: BulkCreateDto): Promise<{ success: boolean; count: number }> => {
    const { data } = await apiClient.post(`/vocabulary/courses/${courseId}/bulk`, dto);
    return data;
  },
};
